import { ViewChild, Input, Component, OnInit, ElementRef } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { ActivatedRoute, Router } from '@angular/router';

import Utils from '../shared/utility';

import { trigger, state, animate, transition, style } from '@angular/animations';
import { start } from 'repl';

import { DecimalPipe } from '@angular/common';
import { CommonModule, CurrencyPipe} from '@angular/common';
import * as internal from 'assert';

@Component({
  selector: 'app-healthcare',
  templateUrl: './healthcare.component.html',
  styleUrls: ['./healthcare.component.css'],
  host: {
		'[@fadeInAnimation]': ''
    },
    animations:[
  		trigger('fadeInAnimation', [ 
        	transition(':enter', [
	            style({
	              opacity: 0,
	            }),
	            animate('1000ms', style({
                opacity: 1,
	            }))
        	]),
    	])
    ]
})
export class HealthCareComponent implements OnInit {
  public pHospMessage: string = "There is no premium cost for Medicare Part A, which covers hospitalization. The premium for Medicare Part B covers doctor visits and test costs.";
  public pDrug: string = "The premium for Medicare Part D covers prescription drug costs.";
  public pSupp: string = "The premium for MediGap covers coinsurance, co-payment and deductible out-of-pocket costs which are not covered by Medicare Parts A and B. MediGap coverage can no longer be purchased to cover Part D prescription drug costs. This coverage is provided through private insurers.";
  public pDental: string = "The premium for dental insurance will cover the standard dental care coverage. Medicare does not cover any routine dental or denture costs.";

  public oopHosp: string = "This represents the annual out-of-pocket costs for doctor visits, tests, etc. which are not covered by the Medicare Part B premium. These costs will be higher if you do not buy MediGap insurance.";
  public oopDrug: string = "This represents the annual out-of-pocket costs which will not be covered by the Medicare Part D premium. This can include the costs which must be paid by an individual if their annual drug costs are between $2750 and $4750 (the 2013 “donut hole” amounts.)";
  public oopHearing: string = "This represents the annual out-of-pocket costs for hearing and vision tests, eyeglasses, etc. which are not covered by Medicare Part B.";
  public oopDental: string = "This represents the annual out-of-pocket costs for dental care, dentures, etc. which are not covered by the standard Dental Insurance policy.";
  public fsMessage: string = "Add any expected income which is earmarked to healthcare cost funding in the inputs below. Contributions will diminish remaining unfunded costs.";
  public investmentSolnMessage: string = "Select up to three unique rates of return throughout the client’s lifetime to produce multiple savings solutions for unfounded future health expenses: a one time investment, annual payments, or weekly payments.";
  public ssMMessage: string = "By law, Medicare deducts the cost of Medicare Part B, as well as potential means testing surcharges on Parts B and D, from Social Security checks.";

  public premiumsInfo: string = "Standard, baseline costs for health coverage, paid either to the government, or the insurance provider.";
  public additionalOOPInfo: string = "Costs not covered by premiums. May include copays, deductibles, and more.";

  public investmentToFundInfo: string = 'Based on rates of return indicated at bottom-center of this page, the one-time lumpsum investment required today to cover projected retirement health costs, after additional funding sources are accounted for.';
  public estimatedFutureInfo: string = 'Projected retirement health care costs, based on checkboxes below, shown in future dollars (otherwise known as "future value")';
  public estimatedTodayInfo: string = 'Projected retirement health care costs, based on checkboxes below, shown in today`s dollars (otherwise known as "net present value")';
  
  public futureCostMessage: string = `Selecting "Today's Dollars" will show costs in the net present value, assuming an annual inflation rate of 3%. Selecting "Future Dollars" will show projected future costs in the given year.`;

  public hcData: any;
  public hcDataV2: any;
  public p1CostsV2: any = [{Premiums:[0,0,0,0,0,0], AdditionalOOP:[0,0,0,0,0,0]}];
  public p2CostsV2: any = [{Premiums:[0,0,0,0,0,0], AdditionalOOP:[0,0,0,0,0,0]}];
  public tempCostsV2: any;

  public beginningBalance: 0;

  public riskToleranceEnabled: boolean = false;
  
  // for existing user who has the access to Risk Tolerane but still hasn't anu Risk Tolerance data
  public portfolioRecommendationVisible: boolean;

  public tempHCData: any;
  public error: string;

  public client: any;
  public inRetirement: boolean = false;

  public projectedFutureLifetimeCosts: number;
  public totalSocialSecurity: number = 0;
  public totalRemainingGap: number = 0;
  public ssRemaining: number = 0;


  public currentRemainingTotal: number = 0;
  public currentRemainingTotalForRiskTolPort: number = 0;

  public fundingItems: any[] = [];
  public partnerActive: boolean = false;

  public coverageTotal: number = 0;
  public premiumCoverageTotal: number = 0;
  public outOfPocketCoverageTotal: number = 0;
  public FrmPV: number = 1;

  public lineChartData: any[];
  public pieChartData: any[];
  public barChartData: any[];

  public fundingSource: any;
  public startAge: any;
  public endAge: any;
  public inflationRate: any;
  public annContribution: any;
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;
  mmtVisible: boolean;
  isAlreadyRetired: boolean;
  displayFiveYearChart: boolean;
  isClientRetiringThisYear: boolean;
  isSpouseRetiringThisYear: boolean;
  annuallyWeeklyTtlYear: number;
  isAssetManagement: boolean = false;
  HCReport: any;
  user:any;
  
  

  @ViewChild('FundingSource') fundingSourceInput:any;
  @ViewChild('AnnContribution') annContributionInput:any;
  @ViewChild('StartAge') startAgeInput:any;
  @ViewChild('EndAge') endAgeInput:any;
  @ViewChild('InflationRate') inflationRateInput:any;

  @ViewChild('rate2') rate2:any; 

  @ViewChild('totalRemainingGapEl') totalRemainingGapEl: ElementRef;
  @ViewChild('totalFutureEstimatedCostsEl') totalFutureEstimatedCostsEl: ElementRef;
  @ViewChild('totalEstimatedCostsEl') totalEstimatedCostsEl: ElementRef;

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;

  @ViewChild('annualEl') annualEl: ElementRef;
  @ViewChild('weeklyEl') weeklyEl: ElementRef;

  
  @ViewChild('pcheck') pcheck: ElementRef;
  @ViewChild('oopcheck') oopcheck: ElementRef;

  @ViewChild('hdt') hdt: ElementRef;
  @ViewChild('pd') pd: ElementRef;
  @ViewChild('si') si: ElementRef;
  @ViewChild('di') di: ElementRef;
  @ViewChild('hd') hd: ElementRef;
  @ViewChild('pdrg') pdrg: ElementRef;
  @ViewChild('hvc') hvc: ElementRef;
  @ViewChild('dins') dins: ElementRef;
  @Input() percentageFormatting: (value: number) => any;

  public premiumExpenses: any = {
    partB: true,
    partD: true,
    medigap: true,
    dental: true
  };

  public outOfPocketExpenses: any = {
    hospitalization: true,
    docsTests: true,
    rx: true,
    dental: true,
    hearingServices: true,
    vision: true,
    commercial: true
  };
  
  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: false,
    timeline: false,
    curve: false,
    tooltipDisabled: false,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    colorScheme: { domain: ['#bad054','#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    yAxisLabel: 'Population',
    roundEdges: false,
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }

  public portfolioRecommendationObject = {
      year: '',
      phase1Portfolio:'',
      phase2Portfolio:'',
      phase1Val: '',
      phase2Val: '',
      clientAge: '',
      spouseAge: '',
      clientRetirementAge: '',
      spouseRetirementAge: '',
      singleInvestment: '',
      unfundedAmount: '', 
      isMarried: false,
      clientRealAge:'',
      clientRealRetirementAge: '',
      spouseFirstName: '',
      spouseLastName: '',
      hcReport: '',
      user: ''

    }

  generateLineChartData(data: any) {

    

    if (this.hcDataV2) {
      let currentYear = new Date().getFullYear();
      let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;

      this.lineChartData = [
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear + i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'Cost', series: []})];
        
    }
  }

  generatePieChartData() {
    var tempTotal = this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }

    
    if (this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1) {
      this.pieChartData = [
        { "name": "Medicare Deduction from Social Security", "value": this.totalSocialSecurity }
      ]
    } else {
      this.pieChartData = [
        { "name": "Unfunded", "value": tempTotal }, 
        { "name": "Medicare Deduction from Social Security", "value": this.totalSocialSecurity }
      ]
    }

    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount })});
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }
  
  generateBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.five = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0;

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0 : this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)
      },
      {
        "name": "5 Years",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0 : this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)
      }
    ]
  }

  constructor(private route: ActivatedRoute, private currencyPipe : CurrencyPipe, private decimalPipe: DecimalPipe, private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService) {
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.hasRiskTolBeenRan = false;
        this.getClient();
      }
    });
  }

  onBlur(event){
    if(event.target.value !== '')
     event.target.value = parseFloat(event.target.value).toFixed(2)
    }

  ngOnInit() {
    if(localStorage.getItem('featRiskTolerance') != 'undefined'){
      this.riskToleranceEnabled = JSON.parse(localStorage.getItem('featRiskTolerance'));
      this.globalService.featRiskTolerance =  this.riskToleranceEnabled;
    }

    if (this.route.snapshot.queryParams['am'] == 1) {
      this.isAssetManagement = true;
    }

    this.getClient();
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange(0);
  }

  editFundingItem(item){

  }

  public futureTotalCost: number;

  public sample: any = {
    ExpenseProjectionBody: "",
    FrmIncome: "",
    FullHorizonYears: "",
    FundingOptions: {},
    Illustrations: [],
    IncomeCompareAnalysis: {},
    P1Age: "",
    P1FullHorizonYears: "",
    P1Gender: "",
    P1HealthCareExpenses: "",
    P1HealthCareExpensesDiscounted: "",
    P1LifeTimeTotalsForComparison: "",
    P2Age: "",
    P2FullHorizonYears: "",
    P2Gender: "",
    P2HealthCareExpenses: "",
    P2HealthCareExpensesDiscounted: "",
    P2LifeTimeTotalsForComparison: "",
    PlanUntil1: "",
    PlanUntilYear: "",
    RetireYear: null,
    RetirementYear: 0,
    State: "",
    TotalProjectedCost: "",
    TotalProjectedCostPv: "",
    TotalYear1Cost: "",
    TotalYear1OOP: "",
    TotalYear1Premiums: "",
    YearOneTotal: "",
    YearsInRetirement: "",
    YearsToRetirement: "",
    hq: null,
    partners: null
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  public investmentOption: number = 1;
  currentYear = new Date().getFullYear();
  getHCData(client: any, includeSpouse?: any, includeSingleInvestment?: any) {
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();
    
    var spouse = {};

    var investmentItems = [];

    for (var item in this.fundingItems) {
      
      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        //this is now set to years
        Begins: this.fundingItems[item].startAge,// + currentYear,
        Ends: this.fundingItems[item].endAge,// - currentAge) + currentYear,

        StartAmount: this.fundingItems[item].annContribution,
        //Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    if (this.client.clientProfile.Spouses 
      && this.client.clientProfile.Spouses.length > 0 
      && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
        this.partnerActive = true;
      } else {
        this.partnerActive = false;
      }

    var HCReport = {
      InvestmentItems: JSON.stringify({ investmentItems }),
      P_Part_A_And_B: this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: 1,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: 0,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      selfConditions: JSON.stringify({
        HCHBP: this.client.clientProfile.HCHBP,
        HCHC: this.client.clientProfile.HCHC,
        HCT2D: this.client.clientProfile.HCT2D,
        HCCD: this.client.clientProfile.HCCD,
        HCC: this.client.clientProfile.HCC,
        HCT: this.client.clientProfile.HCT,
      }),

      spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
        HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
        HCHC: this.client.clientProfile.Spouses[0].HCHC,
        HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
        HCCD: this.client.clientProfile.Spouses[0].HCCD,
        HCC: this.client.clientProfile.Spouses[0].HCC,
        HCT: this.client.clientProfile.Spouses[0].HCT,
      }) : "",

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: 0,

      PaymentTotal: 0,
      PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10),

      FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      // FrmPhase1Periods: includeSingleInvestment ? (this.portfolioRecommendationObject.clientAge ? (Number(this.portfolioRecommendationObject.clientAge) - this.calculateAge(this.client.client.DOB)):0): (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      // FrmPhase2Periods: includeSingleInvestment ? (this.client.clientProfile.RetirementAge ? (Number(this.client.clientProfile.RetirementAge) - Number(this.portfolioRecommendationObject.clientAge)):0): (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      // FrmPhase1Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase1Val ? Number(this.portfolioRecommendationObject.phase1Val):0): (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      // FrmPhase1Periods: includeSingleInvestment ? this.getPhaseAgeDiff(1) : (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      // FrmPhase2Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0): (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      // FrmPhase2Periods: includeSingleInvestment ? this.getPhaseAgeDiff(2) : (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      // FrmPhase3Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0):(this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob) : 0,
      FrmPV: this.FrmPV,
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
      FrmState1: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
      FrmSpouseState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      SelfCurrentIncome: this.client.clientProfile.CurrentIncome,
      SelfIRR: this.client.clientProfile.IRR,
      InvestmentOption: this.investmentOption || 1,
      ClientPIA: this.client.clientProfile.PIA,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
    }

    if (includeSingleInvestment && this.isAlreadyRetired) {
      HCReport.FrmPhase2Rate = HCReport.FrmPhase1Rate;
      HCReport.FrmPhase2Periods = Number(this.client.clientProfile.LifeExpectancy) - Number(this.client.clientProfile.RetirementAge);
      HCReport.FrmPhase3Rate = HCReport.FrmPhase1Rate;
    }

    if (includeSpouse)
      spouse = client.clientProfile.Spouses[0];

    this.client.retirementState = this.client.state;

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }
    this.HCReport = HCReport;
    this.user = user;
    var RiskTolerance = null;
    this.globalService.getHCDataV2(HCReport, user)
    .subscribe(
      data => {
        this.hcDataV2 = data;
        this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);
        this.p1CostsV2 = JSON.parse(this.FrmPV == 0 ? data.P1HealthCareExpensesDiscounted : data.P1HealthCareExpenses);
        this.p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? data.P2HealthCareExpensesDiscounted : data.P2HealthCareExpenses) : {};
        this.tempCostsV2 = this.p1CostsV2;

        if (this.p1CostsV2[0].Total == 0) {
          var tempCosts = [];

          for (var item in this.p2CostsV2) {
            if (this.p2CostsV2[item].Total != 0) {
              tempCosts.push(this.p2CostsV2[item]);
            }
          }

          this.p1CostsV2 = tempCosts;
        }

        if (!this.partnerActive) {
          this.p2CostsV2 = [{Premiums:[0,0,0,0,0,0], AdditionalOOP:[0,0,0,0,0,0]}];
        }

        this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
        if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

          this.hcDataV2.RetirementYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
          this.hcDataV2.RetirementYear = Math.max(currentYear, this.hcDataV2.RetirementYear);

        }

        this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0));
        this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0));
          
        if (this.includePartnerInCalculation) {
          this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3] + this.p2CostsV2[0].AdditionalOOP[0] + this.p2CostsV2[0].AdditionalOOP[1] + this.p2CostsV2[0].AdditionalOOP[2] + this.p2CostsV2[0].AdditionalOOP[3]).toFixed(0));
          this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3] + this.p2CostsV2[0].Premiums[0] + this.p2CostsV2[0].Premiums[1] + this.p2CostsV2[0].Premiums[2] + this.p2CostsV2[0].Premiums[3]).toFixed(0));
          this.hcDataV2.YearOneTotal = Utils.formatToCurrency(Number(this.hcDataV2.YearOneTotal.toString().replace(/,/g, "").replace("$", "")) * 2);
        }

        this.hcDataV2.IncomeCompareAnalysis = JSON.parse(this.hcDataV2.IncomeCompareAnalysis);
        this.hcDataV2.IncomeCompareAnalysis.incomeCompareRows.shift();

        this.futureTotalCost = Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", ""));
        this.projectedFutureLifetimeCosts = Number(this.hcDataV2.TotalProjectedCostPv.toString().replace(/,/g, "").replace("$", ""));


        this.totalSocialSecurity = Number(this.hcDataV2.FundingOptions.PartB.toString().replace(/,/g, "").replace("$", ""));

        this.hcDataV2.Illustrations = JSON.parse(this.hcDataV2.Illustrations);


        this.totalRemainingGap = Number(this.hcDataV2.Illustrations[0].BeginningBalance);

        this.currentRemainingTotalForRiskTolPort = this.futureTotalCost - this.totalSocialSecurity;

        this.currentRemainingTotal = Utils.formatToCurrency(this.futureTotalCost - this.totalSocialSecurity);

        if (this.fundingItems.length > 0) {
          var tempTotal = this.futureTotalCost - this.totalSocialSecurity;

          for (var i = 0; i < this.fundingItems.length; i++) {
            this.fundingItems[i].remainingUnfunded = this.fundingItems[i - 1] ? this.fundingItems[i - 1].remainingUnfunded - this.fundingItems[i].contributionAmount : tempTotal - this.fundingItems[i].contributionAmount;
          }

        }

        this.futureYearlyCost = this.annualEl ? this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * this.annualEl.nativeElement.value : this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * (this.annuallyWeeklyTtlYear < 10 ? 1 : 10);

        this.weeklyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0 : this.hcDataV2.FundingOptions.CalcPayments.WeeklyPaymentAmount;
        this.futureWeeklyCost = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0) :Utils.removeCurrencyFormatting(this.hcDataV2.FundingOptions.CalcPayments.WeeklyPaymentAmount) * 52 * (this.annualEl ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10)));

        

        this.yearlyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0): this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount;
        this.futureYearlyCost = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0 : this.futureYearlyCost);
        this.beginningBalance = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0));
        this.portfolioRecommendationObject.singleInvestment = this.hcDataV2.Illustrations[0] && this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : '$0'
        // SMALLA 012822: Commented this section becaase we need to  pass the single investment in RiskTolerance even the user is single
        // if (includeSingleInvestment) {
        //   this.portfolioRecommendationObject.singleInvestment = this.hcDataV2.Illustrations[0] && this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : '$0'
        //   console.log('this.portfolioRecommendationObject.singleInvestment', this.portfolioRecommendationObject.singleInvestment)
        // }

        // this.displayFiveYearChart = !this.inRetirement;

        // If client is dying before or same year as retirement
        // Adjust the full horizon years
        if (currentYear + Math.max(0, Number(this.client.clientProfile.LifeExpectancy) - Number(this.calculateAge(this.client.client.DOB))) <= currentYear + Math.max(0, Number(this.client.clientProfile.RetirementAge) - Number(this.calculateAge(this.client.client.DOB))))  {
          this.hcDataV2.P1FullHorizonYears = this.hcDataV2.P1FullHorizonYears - 1;
        }

        this.generateLineChartData({});
        this.generatePieChartData();
        this.generateBarChartData();
        this.getPortfolioRecommendation();

      
      },
      error => this.error = <any>error);
  }

  getPhaseDiff(phase) {
    const clientAge = Number(this.calculateAge(this.client.client.DOB));
    const clientRetirementAge = Number(this.client.clientProfile.RetirementAge);
    const clientLE = Number(this.client.clientProfile.LifeExpectancy);
    const spouseAge = Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) || 0;
    const spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge) || 0;
    const spouseLE = Number(this.client.clientProfile.Spouses[0].LifeExpectancy) || 0;

    // console.log(
    //   clientAge,
    //   clientRetirementAge,
    //   clientLE,
    //   spouseAge,
    //   spouseRetirementAge,
    //   spouseLE
    // );

    if (spouseAge && spouseRetirementAge) {
      if (phase == 1)
        return Math.min(Math.max(0, clientRetirementAge - clientAge), Math.max(0, spouseRetirementAge - spouseAge));
      if (phase == 2)
        return Math.min(Math.max(0, clientLE - clientRetirementAge), Math.max(0, spouseLE - spouseRetirementAge));
    } else {
      if (phase == 1)
        return Math.max(0, clientRetirementAge - clientAge);
      if (phase == 2)
        return Math.max(0, clientLE - clientRetirementAge);
    }
  }

  getPhaseAgeDiff(phase) {
    let clientYearsToRetire = 0;
    let spouseYearsToRetire = 0;
    let clientRetirementYears = 0;
    let spouseRetirementYears = 0;
    
    if (phase === 1) {
      clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
      spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
      return Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire)
    } else {
      clientRetirementYears = Math.max(0, Number(this.client.clientProfile.LifeExpectancy)) - Number(this.portfolioRecommendationObject.clientRetirementAge);
      spouseRetirementYears = Math.max(0, Number(this.client.clientProfile.Spouses[0].LifeExpectancy)) - Number(this.portfolioRecommendationObject.spouseRetirementAge);
      return Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientRetirementYears, spouseRetirementYears) : Math.max(0, clientYearsToRetire)
    }    
  }

  // TODO: Make utility file
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  ngAfterViewInit() {
    if (this.client) {
      let rateAssumptionYears = Utils.calculateRateAssumptionYears( this.calculateAge(this.client.client.DOB), this.client.clientProfile.LifeExpectancy);
 
      if (!this.riskToleranceEnabled) {
        this.p1EndAge.nativeElement.value = rateAssumptionYears.p1EndAge;
      }
      this.p2EndAge.nativeElement.value = rateAssumptionYears.p2EndAge;
           
    }
  }

  public includePartnerInCalculation: boolean = false;

  getClient() {    
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
    .subscribe(
        client => { 
          this.client = client;
          let dOB = new Date(this.client.client.DOB);
          let timeDiff = Math.abs(Date.now() - dOB.getTime());
          let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
          this.annuallyWeeklyTtlYear = this.client.clientProfile.RetirementAge - clientAge;
          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

          if (this.client.clientProfile.Spouses.length > 1) {
            this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
          }

          this.inRetirement = this.calculateAge(this.client.client.DOB) >= this.client.clientProfile.RetirementAge;

          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            this.partnerActive = true;

            // this.inRetirement = this.inRetirement && this.calculateAge(this.client.clientProfile.Spouses[0].dob) >= this.client.clientProfile.Spouses[0].retirementAge;

            if (Math.abs((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) - (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB))) == 0 ||
            Math.abs((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) - (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB))) == 1 ) {
              this.client.client.DOB = new Date(new Date(this.client.client.DOB).getFullYear(), 0, 1).toLocaleDateString('en-US');
              this.client.clientProfile.Spouses[0].dob = new Date(new Date(this.client.clientProfile.Spouses[0].dob).getFullYear(), 0, 1).toLocaleDateString('en-US');
              this.includePartnerInCalculation = true;
            } else {
              this.includePartnerInCalculation = false;
            }
          } else {
            this.partnerActive = false;
          }

          this.displayFiveYearChart = !this.inRetirement;

          if(localStorage.getItem('featRiskTolerance') != 'undefined'){
            this.riskToleranceEnabled = JSON.parse(localStorage.getItem('featRiskTolerance'));
          }

          this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
          
          this.getHCData(client);
        },
        error => this.error = <any>error);
  }

  
  formatNumber(amount) {
    return Math.round(amount);
  }

  formatNumber2(amount) {
    amount = amount.toFixed(0);
    return Utils.formatToCurrency(amount);
  }

  handleSavingRiskToleranceHC() {
    let HCValues = this.getHealthcarePDfValues();
    HCValues.Report.ReportTypeID = 5;

    this.globalService.createReportHC(HCValues.Report, HCValues.ReportHC)
    .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your risk tolerance healthcare report is being generated.", 0);
        
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
        error => this.error = <any>error);
  }

  handleSavingHC() {
    let HCValues = this.getHealthcarePDfValues();

    this.globalService.createReportHC(HCValues.Report, HCValues.ReportHC)
    .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your healthcare report is being generated.", 0);
        
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
        error => this.error = <any>error);
  }

  getHealthcarePDfValues() {
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 3,
    }


    var investmentItems = [];

    var investmentItem;

    var currentAge = this.calculateAge(this.client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {
      
      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    var ReportHC = {
      InvestmentItems: JSON.stringify({ InvestmentItems: { Items: investmentItems}}),
      P_Part_A_And_B: this.hdt.nativeElement.checked ? 1 : 0,
      P_Part_D: this.pd.nativeElement.checked ? 1 : 0,
      P_MediGap: this.si.nativeElement.checked ? 1 : 0,
      P_Dental: this.di.nativeElement.checked ? 1 : 0,
      OOP_Hosp_Docs: this.hd.nativeElement.checked ? 1 : 0,
      OOP_Presc_Drug: this.pdrg.nativeElement.checked ? 1 : 0,
      OOP_Hearing_Vision: this.hvc.nativeElement.checked ? 1 : 0,
      OOP_Dental: this.dins.nativeElement.checked ? 1 : 0,
      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: 1,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: 0,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      FrmPlanUntil: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil1:  this.hcDataV2.PlanUntil1 || 0,
      SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1 || 0,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0 || 0,
      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: 0,

      PaymentTotal: 0,
      PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10),

      FrmIncome: this.hcDataV2.FrmIncome,

      FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      // FrmPhase1Periods: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.clientAge ? (Number(this.portfolioRecommendationObject.clientAge) - this.calculateAge(this.client.client.DOB)):0): (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      // FrmPhase2Periods: this.riskToleranceEnabled ? (this.client.clientProfile.RetirementAge ? (Number(this.client.clientProfile.RetirementAge) - Number(this.portfolioRecommendationObject.clientAge)):0): (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      // FrmPhase1Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase1Val ? Number(this.portfolioRecommendationObject.phase1Val):0): (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
      // FrmPhase1Periods: this.riskToleranceEnabled ? this.getPhaseAgeDiff(1) : (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
      // FrmPhase2Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0): (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
      // FrmPhase2Periods: this.riskToleranceEnabled ? this.getPhaseAgeDiff(2) : (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
      // FrmPhase3Rate: this.riskToleranceEnabled ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0):(this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob) : 0,
      FrmPV: this.FrmPV,
      FrmRetireYear0: this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB),
      FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
      FrmState1: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
      FrmSpouseState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
      FundCosts: this.futureTotalCost,
      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,
      InvestmentOption: this.investmentOption || 1,
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
    }

    // if (this.riskToleranceEnabled && this.isAlreadyRetired) {
    //   ReportHC.FrmPhase2Rate = ReportHC.FrmPhase1Rate;
    //   ReportHC.FrmPhase2Periods = Number(this.client.clientProfile.LifeExpectancy) - Number(this.client.clientProfile.RetirementAge);
    //   ReportHC.FrmPhase3Rate = ReportHC.FrmPhase1Rate;
    // }

    return { Report, ReportHC }
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer"), retirementAge: this.client.clientProfile.RetirementAge, spouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge || 0 };

    this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  formatPercent(percentage) {
    return (percentage * 100).toFixed(0);
  }

  handleNewFundingItem(fundingSource: string, annContribution: any, startAge: number, endAge: number, inflationRate: number) {
    this.hasRiskTolBeenRan = false; 
    
    //check year here
    if(startAge < this.currentYear){
      startAge = this.currentYear;
    }

    if(endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear){
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }
    
    annContribution = Utils.formatToNumber(annContribution).toFixed(0);
    var contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);
    
    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(contributionAmount),      
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });


    this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = '';    

    
    this.getHCData(this.client);

  }

  getFutureValue(startAmount, years, inflation) {
    inflation = inflation / 100;
    var total = 0;


    for (var i = 0; i <= years; i++) {
      total = total + startAmount * Math.pow(1 + inflation, i);
    }

    return total;
  }

  getFutureValueOfCost(startAmount, years, inflation) {
    return startAmount * Math.pow(1 + inflation, years);
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  getFutureContributionAmount(startAmount, years, inflation, startAge, idx) {
    var startingBalance = 0;
    var interestEarned = 0;
    var contribution = Number(startAmount);
    var endingBalance = Number(startAmount);
    startAge = Number(startAge);

    for (let i = 0; i < years; i++) {
      if (startAge + i <= this.p1EndAge.nativeElement.value)
      {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p1Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution; 
      } else if (startAge + i <= this.p2EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p2Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution; 
      } else {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p3Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution; 
      }
    }

    if (idx != null) {
      this.fundingItems[idx].remainingUnfunded = Number(this.totalRemainingGap - endingBalance).toFixed(0);
      this.fundingItems[idx].contributionAmount = Number(endingBalance).toFixed(0);
    }

    return Number(endingBalance).toFixed(0);
  }

  onRateChange(percentValue) {
    
    //get HC data
    this.getHCData(this.client, this.partnerActive);

    //check value
    if(percentValue != undefined){
      if(percentValue.value > 12){
        return percentValue.value = 12;
      }
    }
  }

  public visible: boolean = true;

  calculateCoverageTotal(el?: any, amount?: number, isPremium?: boolean, coverageKeyName?: string[]) {
    this.hasRiskTolBeenRan = false;

    //figure out if remove the 'check all'
    if(el){
      if(!el.checked && isPremium){
        this.enabledAllPremiumsChecked = false;
        this.pcheck.nativeElement.checked = false;
      }

      if(!el.checked && !isPremium){
        this.enabledAllOOPChecked = false;
        this.oopcheck.nativeElement.checked = false;
      }
    }

    this.premiumExpenses = {
      partB: this.hdt.nativeElement.checked,
      partD: this.pd.nativeElement.checked,
      medigap: this.si.nativeElement.checked,
      dental: this.di.nativeElement.checked
    };
  
    this.outOfPocketExpenses = {
      hospitalization: this.hd.nativeElement.checked,
      docsTests: this.hd.nativeElement.checked,
      rx: this.pdrg.nativeElement.checked,
      dental: this.dins.nativeElement.checked,
      hearingServices: this.hvc.nativeElement.checked,
      vision: this.hvc.nativeElement.checked,
      commercial: true
    };

    

    if (
      !this.premiumExpenses.partB &&
      !this.premiumExpenses.partD &&
      !this.premiumExpenses.medigap &&
      !this.premiumExpenses.dental &&
      !this.outOfPocketExpenses.hospitalization &&
      !this.outOfPocketExpenses.docsTests &&
      !this.outOfPocketExpenses.rx &&
      !this.outOfPocketExpenses.dental &&
      !this.outOfPocketExpenses.hearingServices &&
      !this.outOfPocketExpenses.vision
    ) {
      this.visible = false;
      this.hcDataV2 = this.sample;
    } else {
      this.visible = true;
      this.getHCData(this.client, this.partnerActive);

      this.coverageTotal = el.checked ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

      if (isPremium)
        this.premiumCoverageTotal = el.checked ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
      else
        this.outOfPocketCoverageTotal = el.checked ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

      this.generateLineChartData({});
    }
  }

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  animateValue(el, start, formattedNumber): void  {
    var end = parseFloat(formattedNumber.shortValue);
    var current = start;
    var increment = start < 0 ? -1 : 1;
    var stepTime = Math.abs(1);

    if (formattedNumber.shortValue > 0) {
      el.nativeElement.innerHTML = `$${end.toFixed(2)}${formattedNumber.suffix || ''}`;
      
    } else {
      el.nativeElement.innerHTML = `$0`;
    }
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed),
        d = c < 0 ? c : Math.abs(c),
        e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  public weeklyCost: Number = 0;
  public yearlyCost: Number = 0;

  public futureYearlyCost: Number = 0;
  public futureWeeklyCost: Number = 0;

  calcAnnualSavings(el, el2) {

    el2.value = el.value;

    this.getHCData(this.client);
  }

  calcWeeklySavings(isAnnual) {
    if (isAnnual)
      this.weeklyEl.nativeElement.value = this.annualEl.nativeElement.value;
    else 
      this.annualEl.nativeElement.value = this.weeklyEl.nativeElement.value;
    this.getHCData(this.client);

  }

  handleIllustrationModal(e) {
    
    if (this.hcDataV2.IllustrationEntriesWithFunding) {
      var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
        return {
          Year: this.currentYear,
          clientAge: this.calculateAge(this.client.client.DOB),
          spouseAge: (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0, 
          BeginningBalance: Utils.formatToCurrency(entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
          ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%': 0),
          Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
          Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
          NetOfSSDeductions: Utils.formatToCurrency(entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)),
          EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
        }
      });  
      this.modalService.add('hc-projections', { Data: projectedYears });
    }
    
  }

  enabledAllPremiumsChecked = false;
  checkAllPremiums() {
    this.enabledAllPremiumsChecked = this.pcheck.nativeElement.checked;

    this.hdt.nativeElement.checked = this.enabledAllPremiumsChecked;
    this.pd.nativeElement.checked = this.enabledAllPremiumsChecked;
    this.si.nativeElement.checked = this.enabledAllPremiumsChecked;
    this.di.nativeElement.checked = this.enabledAllPremiumsChecked;

    this.calculateCoverageTotal();
  }

  enabledAllOOPChecked = false;
  checkAllOOP() {
    this.enabledAllOOPChecked = this.oopcheck.nativeElement.checked;

    this.hd.nativeElement.checked = this.enabledAllOOPChecked;
    this.hvc.nativeElement.checked = this.enabledAllOOPChecked;
    this.dins.nativeElement.checked = this.enabledAllOOPChecked;
    this.pdrg.nativeElement.checked = this.enabledAllOOPChecked;

    this.calculateCoverageTotal();
  }

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.getHCData(this.client);
  }

  
  valueToggle(e) {
    this.FrmPV = Number(e.target.value);
    this.getHCData(this.client, this.partnerActive);
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val<0?0:val));
  }
  
  formatNumber3(val) {

    return Utils.formatToNumber(val);
  }

  formatNumber4(val1) {

    return Utils.formatToNumber(val1);
  }

  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
        this.showAnnContrBorder = false;
      } else {
        this.showAnnContrBorder = true;
    } 

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }

  }

  public hasRiskTolBeenRan: boolean = false;

  getPortfolioRecommendation() {
    if(localStorage.getItem('featRiskTolerance') == 'undefined'){
      return;
    }

    if (JSON.parse(localStorage.getItem('featRiskTolerance')) && !this.hasRiskTolBeenRan) {
      let unfundeHealthCareCost = 0;
      unfundeHealthCareCost = this.currentRemainingTotalForRiskTolPort ? this.currentRemainingTotalForRiskTolPort: 0;
      for(var item of this.fundingItems) {
  
        if (item.remainingUnfunded) {
          unfundeHealthCareCost += item.remainingUnfunded;
        }
      }
      let isClientRetiringFirst = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) <= Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : true;
      let isClientRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) < 0 ? true: false)  :false ;
			let isSpouseRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) < 0 ? true: false)  :false ;
      let clientAge = '';
      let clientRetirementAge = '';

      if((isClientRetired && isSpouseRetired) || (!isClientRetired && !isSpouseRetired)) {
        clientAge = isClientRetiringFirst ? JSON.stringify(this.calculateAge(this.client.client.DOB)) : JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = isClientRetiringFirst ? JSON.stringify(this.client.clientProfile.RetirementAge) : this.client.clientProfile.Spouses[0].retirementAge;
      } else if (isClientRetired) {
        clientAge = JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = this.client.clientProfile.Spouses[0].retirementAge;
      } else {
        clientAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
        clientRetirementAge = JSON.stringify(this.client.clientProfile.RetirementAge);
      }
      var riskTolerance = {
        ClientID: localStorage.getItem('selectedClient'),
        ClientAge: clientAge,
        ClientRetirementAge: clientRetirementAge,
        estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        unfundedHealthCareCost: JSON.stringify(unfundeHealthCareCost)
      }
      this.globalService.getRiskTolerancePortfolio(riskTolerance).subscribe(
        resp => {
          let clientRealAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
          if (resp.PhaseOneRecommend) {
            this.portfolioRecommendationVisible = true;
          }
          this.portfolioRecommendationObject = {
            year: String(isClientRetiringFirst ? this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB) : this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)),
            phase1Portfolio: resp.PhaseOneRecommend,
            phase2Portfolio: resp.PhaseTwoRecommend,
            phase1Val: resp.PhaseOneROR,
            phase2Val: resp.PhaseTwoROR,
            clientAge: clientAge,
            spouseAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? `${this.calculateAge(this.client.clientProfile.Spouses[0].dob)}` : '0' ,
            clientRetirementAge: clientRetirementAge,
            spouseRetirementAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].retirementAge : '0' ,
            singleInvestment: (resp.SingleInvestment && resp.SingleInvestment != 0) ? Utils.formatToCurrency(resp.SingleInvestment) : this.portfolioRecommendationObject.singleInvestment,
            unfundedAmount: this.futureTotalCost ? String(Utils.formatToCurrency(this.futureTotalCost)): '$0',
            isMarried: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true: false,
            clientRealAge: clientRealAge,
            clientRealRetirementAge: this.client.clientProfile.RetirementAge,
            spouseFirstName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].firstName: '',
            spouseLastName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].lastName: '',
            hcReport: this.HCReport,
            user: this.user
          }
          if (Number(clientAge) >= Number(this.client.clientProfile.RetirementAge)) {
            this.isAlreadyRetired = true;
          } else {
            this.isAlreadyRetired = false;
          }

          this.hasRiskTolBeenRan = true;
          // this.getHCData(this.client, this.partnerActive, true);
        },
        error => {
          this.error = <any>error;
        });
    }
  }

  handleAssetManagementModal(event) {
    //clear on call
    localStorage.removeItem('riskTolReportObject');

    //reset
    var report = this.getHealthcarePDfValues();
    localStorage.setItem('riskTolReportObject', JSON.stringify(report));
    console.log('this.portfolioRecommendationObject', this.portfolioRecommendationObject)
    this.modalService.add('risk-tolerance', {ID: this.client.client.ID, FirstName: this.client.client.FirstName, LastName: this.client.client.LastName,
     AdvisorFee: this.client.client.ProgramFeePercent, TotalSocialSecurity: this.totalSocialSecurity, FurureTotalCost: this.futureTotalCost, PortfolioRecommendationObject: this.portfolioRecommendationObject, Page: 'HC'});
  }
}